import React, { useEffect, useRef, useState } from 'react';

interface BackgroundVideoProps {
  images: string[];
  title: string;
  callToAction: string;
}

const BackgroundVideo: React.FC<BackgroundVideoProps> = ({ images, title, callToAction }) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    const slideshowTimer = setInterval(() => {
      setCurrentImageIndex((prevIndex) => 
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 3000);

    // Scroll fade effect
    const handleScroll = () => {
      if (contentRef.current) {
        const scrollPosition = window.scrollY;
        const opacity = 1 - Math.min(scrollPosition / 500, 1);
        contentRef.current.style.opacity = opacity.toString();
      }
    };

    window.addEventListener('scroll', handleScroll);
    
    return () => {
      clearInterval(slideshowTimer);
      window.removeEventListener('scroll', handleScroll);
    };
  }, [images.length]);

  const handleCtaClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const roomsSection = document.getElementById('rooms');
    if (roomsSection) {
      roomsSection.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <section className="hero-section">
      <div className="slideshow-wrapper">
        {images.map((image, index) => (
          <div
            key={index}
            className={`slideshow-image ${index === currentImageIndex ? 'active' : ''}`}
            style={{ 
              backgroundImage: `url(${image})`,
              transform: index === currentImageIndex ? 'scale(1.1)' : 'scale(1)', // Start from scale(1) and zoom to scale(1.1)
              transition: 'transform 3s ease-in-out' // Smooth transition for zoom
            }}
          />
        ))}
        <div className="overlay"></div>
      </div>
      <div className="hero-content" ref={contentRef}>
        <div className="content-wrapper">
          {/* <h1 dangerouslySetInnerHTML={{ __html: title }} /> */}
          <a href="#rooms" 
             className="cta-button"
             onClick={handleCtaClick}
          >
            {callToAction}
          </a>
        </div>
      </div>
    </section>
  );
};

export default BackgroundVideo;